import { render, staticRenderFns } from "./ParleList.vue?vue&type=template&id=2a634658&"
import script from "./ParleList.vue?vue&type=script&lang=js&"
export * from "./ParleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports